export const parseSafe = (string: string) => {
    try {
        return JSON.parse(string);
    } catch (error) {
        console.error('Failed to parse JSON string:', error);
        return null;
    }
}